export default "__VITE_ASSET__DdQpzt5k__"